/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Remove_DayInputs */

const en_us2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.session}`)
};

const pt_br2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluir ${i?.session}`)
};

const es_419_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar ${i?.session}`)
};

const pt_pt2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar ${i?.session}`)
};

const fr_fr2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.session}`)
};

const de_de2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} löschen`)
};

const it_it2_plan_build_remove_day = /** @type {(inputs: Plan_Build_Remove_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elimina ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Delete {session}" |
*
* @param {Plan_Build_Remove_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_remove_day = /** @type {((inputs: Plan_Build_Remove_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Remove_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_remove_day(inputs)
	if (locale === "es-419") return es_419_plan_build_remove_day(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_remove_day(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_remove_day(inputs)
	if (locale === "de-DE") return de_de2_plan_build_remove_day(inputs)
	if (locale === "it-IT") return it_it2_plan_build_remove_day(inputs)
	return en_us2_plan_build_remove_day(inputs)
});
export { plan_build_remove_day as "plan-build.remove_day" }